// extracted by mini-css-extract-plugin
export default {"container":"ForgotPasswordTerminal_container__Mkviz","text":"ForgotPasswordTerminal_text__FJ9Rg","groupButton":"ForgotPasswordTerminal_groupButton__p-Vc3"};